import { theme, useResponsive } from "@product/scmp-sdk";
import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { useEffect, useState } from "react";

import { computeGaLabelSharingUrl } from "~/components/content/content-share-widget/helpers";
import IconShare from "~/components/header/header-icon/share.svg";
import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { currentArticleAtom } from "~/lib/current-item";

import { StyledDynamicContentShareWidget, StyledDynamicDrawer } from "./styles";

export const HeaderContentShareWidgetDrawer: FunctionComponent = () => {
  const currentArticle = useAtomValue(currentArticleAtom);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const isTabletUp = useResponsive(theme.breakpoints.up("tablet"), true);
  useEffect(() => {
    setIsOpenDrawer(false);
  }, [isTabletUp]);

  if (!currentArticle) return null;
  const { sharingUrl } = computeGaLabelSharingUrl(currentArticle);

  return (
    <>
      <IconShare
        height={16}
        width={16}
        onClick={() => {
          sendGATracking({
            action: "Share menu button/Click",
            category: "Share button (Adhesive)",
            label: sharingUrl,
          });
          setIsOpenDrawer(true);
        }}
      />
      <StyledDynamicDrawer
        anchor="bottom"
        open={isOpenDrawer}
        PaperProps={{
          sx: {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          },
        }}
        title="Share"
        withClose
        onClose={() => setIsOpenDrawer(false)}
      >
        <StyledDynamicContentShareWidget
          extraProps={{
            copyLink: {
              variant: "label",
            },
          }}
          position="article_adhesive"
          reference={currentArticle}
          types={[
            "facebook",
            "twitter",
            "whatsapp",
            "email",
            "messenger",
            "line",
            "telegram",
            "copy-link",
          ]}
          showLabel
          onClick={() => setTimeout(() => setIsOpenDrawer(false), 1000)}
        />
      </StyledDynamicDrawer>
    </>
  );
};

HeaderContentShareWidgetDrawer.displayName = "HeaderContentShareWidgetDrawer";
